interface IconProps {
    width?: string;
    height?: string;
    className?: string;
}

const CarIcon = ({ width = '20', height = '20', className = '' }: IconProps) => {
    return (
        <span className={className}>
            <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.9247 2.3584H7.07467C4.99967 2.3584 4.54134 3.39173 4.27467 4.6584L3.33301 9.16673H16.6663L15.7247 4.6584C15.458 3.39173 14.9997 2.3584 12.9247 2.3584Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.3253 16.517C18.4169 17.492 17.6336 18.3337 16.6336 18.3337H15.0669C14.1669 18.3337 14.0419 17.9503 13.8836 17.4753L13.7169 16.9753C13.4836 16.292 13.3336 15.8337 12.1336 15.8337H7.86693C6.66693 15.8337 6.49194 16.3503 6.2836 16.9753L6.11694 17.4753C5.9586 17.9503 5.8336 18.3337 4.9336 18.3337H3.36694C2.36694 18.3337 1.5836 17.492 1.67527 16.517L2.14194 11.442C2.2586 10.192 2.50027 9.16699 4.6836 9.16699H15.3169C17.5003 9.16699 17.7419 10.192 17.8586 11.442L18.3253 16.517Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.33333 6.66699H2.5"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.5003 6.66699H16.667"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 2.5V4.16667"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.75 4.16699H11.25"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 12.5H7.5"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.5 12.5H15"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    );
};

export default CarIcon;
